/** Sem 0, 1, I e O: o trader le o codigo pro suporte sem confundir letra com numero. */
const ALFABETO = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
/**
 * Codigo curto de um pedido HTTP ou de um erro de tela ("7F3K2QXA"). Vai no cabecalho `x-codigo`, em toda linha de log
 * e como marca no Sentry: quem ve o erro manda o codigo e a gente acha o que aconteceu na hora.
 */
export function novoCodigo(tamanho = 8) {
    const bytes = new Uint8Array(tamanho);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => ALFABETO[b % ALFABETO.length]).join("");
}
//# sourceMappingURL=codigo.js.map